import { PartnerType } from "@/app/utils/partners.enum";
import { streamRequest, StreamOptions } from "../http/sseClient";

export type ConsentimentoItem = {
  consentimentoId: string;
  codInstituicao: string;
  statusConsentimento: string;
};

export type DadoConsentimento = {
  dadosConsentimentoId: string;
  consentimentoId?: string;
  codigoBanco: string;
  nomeBanco: string;
  agencia: string;
  conta: string;
  digitoConta: string;
  tipoConta: string;
};

export type GetConsentResponse = {
  consentimentoRealizado: boolean;
  consentimentos: ConsentimentoItem[];
  dadosConsentimento: DadoConsentimento[];
  mensagem: string;
};

export async function getConsent(clientId: string, options?: StreamOptions) {
  return streamRequest<GetConsentResponse>({
    method: "GET",
    path: `/crefisa/consent/${clientId}`,
    journey: PartnerType.CREFISA,
    ...options,
  });
}
